import "./Divider";
import "./Blot";
import Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ImageResize from "quill-image-resize-module"; // 调整大小组件。
import { ImageDrop } from "quill-image-drop-module"; // 拖动加载图片组件。

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);



// WEBPACK FOOTER //
// ./src/plugins/quill/index.js